exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".WhatsNewNavItem__bellIcon___1rgga {\n  color: var(--vds-navigation-color);\n}\n", ""]);

// exports
exports.locals = {
	"bellIcon": "WhatsNewNavItem__bellIcon___1rgga"
};